import React, { useEffect } from 'react';
import SiteHeader from '../../shared/SiteHeader';
import SiteFooter from '../../shared/SiteFooter';
import ContactForm from './ContactForm';
import { getAppInsights } from '../../appInsights';

const About: React.FC = () => {
  useEffect(() => {
    document.title = 'Todonyx LLC - About';
    const ai = getAppInsights();
    ai?.trackPageView({ name: 'About' });
  }, []);

  return (
    <div className="page-wrapper">
      <SiteHeader />
      <main className="page-content container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8">
            <h1 className="display-5 fw-bold mb-4">About Todonyx</h1>
            <p className="lead mb-4">
              Todonyx LLC is dedicated to creating AI-driven applications that enhance productivity
              and creativity. Our flagship product, Walk It With Me, is designed to assist users in
              exploring and applying biblical teachings through advanced AI technology.
            </p>

            <div className="card shadow-sm mb-4">
              <div className="card-body p-4">
                <h2 className="h4 mb-3">Our Mission</h2>
                <p>
                  We believe in harnessing the power of technology to make meaningful tools that
                  improve improve people's lives. Whether through spiritual guidance or professional
                  development solutions, we're committed to excellence and innovation.
                </p>
              </div>
            </div>

            <div className="card shadow-sm">
              <div className="card-body p-4">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default About;
